export { DescListComponent } from './desc-list.component';
export { DescListItemComponent } from './desc-list-item.component';
export { AdDescListModule } from './desc-list.module';
